export interface PaginateObj<T> {

    pageNumber: number,
    pageSize: number,
    firstPage: string,
    lastPage: string,
    totalPages: number,
    totalRecords: number,
    nextPage: string,
    previousPage: string,
    data: T[],
    succeeded: boolean,
    errors: string,
    message: string
}

export function GetVoidPaginateObj(): PaginateObj<any> {
    return {
        pageNumber: 1,
        pageSize: 1,
        firstPage: '',
        lastPage: '',
        totalPages: 1,
        totalRecords: 0,
        nextPage: '',
        previousPage: '',
        data: [],
        succeeded: true,
        errors: '',
        message: ''
    }
}